import * as React from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {useEffect, useState} from "react";
import news from '../../models/news'
import helpers from "../../helpers/common";
import useRootHook from "../../hooks/useRoot";
import {Add, Check} from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {Link as RouterLink} from "react-router-dom";
import PageHeader from '../layout/PageHeader';
import SectionCard from '../layout/SectionCard';
import TableToolbar from '../layout/TableToolbar';
import {Chip} from "@mui/material";

export default function NewsIndex(props) {
    const [newsData, setNewsData] = useState([])
    const {setShowLoader} = useRootHook()

    useEffect(() => {
        setShowLoader(true)
        news.getData()
            .then((data) => {
                if (data && data.news) {
                    setNewsData(data.news)
                }
                setShowLoader(false)
            }).catch(() => setShowLoader(false))
    }, [])

    return <React.Fragment>
        <Grid size={12}>
            <PageHeader
                title="News"
                breadcrumbs={[['Dashboard', '/'], ['News', '/news']]}
                actions={
                    <Button to="/news/add" component={RouterLink} variant="contained" startIcon={<Add />}>
                        Add news
                    </Button>
                }
            />
        </Grid>
        <Grid size={12}>
            <SectionCard sx={{ display: 'flex', flexDirection: 'column', overflowX: 'auto' }}>
                <TableToolbar title="News" />
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Title</TableCell>
                            <TableCell>Content</TableCell>
                            <TableCell>Enabled</TableCell>
                            <TableCell>Date Created</TableCell>
                            <TableCell>Date Modified</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {newsData.map((row) => (
                            <TableRow key={`news-${row.id}`}>
                                <TableCell>
                                    <Link color="primary" to={`edit?id=${row.id}`} component={RouterLink}>
                                        {helpers.cutLongString(row.title, 50)}
                                    </Link>
                                </TableCell>
                                <TableCell>{helpers.cutLongString(row.content, 100)}</TableCell>
                                <TableCell>
                                    {row.enabled ? (
                                        <Chip size="small" label="Enabled" color="success" />
                                    ) : (
                                        <Chip size="small" label="Disabled" color="default" />
                                    )}
                                </TableCell>
                                <TableCell>{helpers.getDate(row.created)} {helpers.getTime(row.created)}</TableCell>
                                <TableCell>{helpers.getDate(row.modified)} {helpers.getTime(row.modified)}</TableCell>
                            </TableRow>
                        ))}
                        {newsData.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    No news found
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </SectionCard>
        </Grid>
    </React.Fragment>
}

